interface LoadingSpinnerProps {
    size?: string;
    colorClass?: string;
}

const LoadingSpinner = (props: LoadingSpinnerProps) => {
    const sizeClass = props.size ?? "h-xxl w-xxl";
    const colorClass = props.colorClass ?? "border-p6-orange-pastel border-t-p6-orange";

    return (
        <div
            className={`animate-spin [animation-duration:800ms] rounded-pill border-4 ${colorClass} ${sizeClass}`}
        />
    );
};

export default LoadingSpinner;
